/* Get header and footer heights */
document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.section-header');
  var footer = document.querySelector('.section-footer');
  var packshot = document.querySelector('.release__packshot');
  var featuredCollection = document.querySelector('.featured-collection .card--media .card__inner');

  var headerHeight = header.offsetHeight;
  var footerHeight = footer.offsetHeight;
  var packshotHeight = packshot.offsetHeight;
  var featuredCollection = featuredCollection.offsetHeight;

  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
  document.documentElement.style.setProperty('--packshot-height', footerHeight + 'px');
  document.documentElement.style.setProperty('--featured-merch-height', featuredCollection + 'px');
});

/* Add scrolling class */
window.addEventListener('scroll', function() {
  if (window.scrollY > 10) {
    document.body.classList.add('scrolling');
  } else {
    document.body.classList.remove('scrolling');
  }
});

/* Format titles */
const headings = document.querySelectorAll('.card__heading, .product__title h1, .featured-product .product__title, .cart-item__name, .page-title, .related-products .card__heading.h5, .card__heading.h5');

headings.forEach(heading => {
  heading.innerHTML = heading.innerHTML.replace(/\|/g, '<br><small />');
});

/* Add blank target */
document.querySelectorAll('a[href="https://www.wearesuper.co/architects"]').forEach(link => {
    link.setAttribute('target', '_blank');
});